import { routeName } from '~/@common/constants'
import { guestLoginService } from '~/@pages/login/guest/guestLoginService'

// 개발 환경에서 window.testUtils로 노출되는 콘솔 테스트 유틸
// 사용법: window.testUtils.generateGuestLoginPath('아이디', '비밀번호')
//         window.testUtils.generateGuestLoginPath('아이디', '비밀번호', 'hex키(64자)')
export const testUtils = (() => {
  const utils = {
    generateGuestLoginPath: async (id: string, pw: string, key?: string) => {
      const encryptedId = await guestLoginService.encryptWithAES(id, key)
      // ID 암호화에서 생성/사용된 키를 PW 암호화에도 동일하게 사용
      const encryptedPw = await guestLoginService.encryptWithAES(pw, encryptedId.key)

      const params = new URLSearchParams({
        id: encryptedId.encrypted,
        pw: encryptedPw.encrypted,
        key: encryptedId.key,
        ivId: encryptedId.iv,
        ivPw: encryptedPw.iv,
      })

      const path = `${routeName.auth.guestLogin}?${params.toString()}`
      return path
    },
  }

  return {
    initialize: () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ;(window as any).testUtils = utils
    },
  }
})()
